<!-- src/layouts/appLayout.vue -->
<template>
  <Loading v-if="app.isLoading" />
  <router-view />
</template>

<script setup>
import { useAppStore } from "@/stores/appStore";
import Loading from "@/components/loading";

const app = useAppStore();
</script>

<style scoped></style>